"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Delete = void 0;
var React = require("react");
var theme_1 = require("../../theme");
var Delete = function (_a) {
    var _b = _a.color, color = _b === void 0 ? theme_1.colors.black : _b, _c = _a.style, style = _c === void 0 ? {} : _c;
    return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", style: style },
        React.createElement("defs", null,
            React.createElement("path", { d: "M6,10 L18,10 L18,18 C18,19.1 17.1,20 16,20 L8,20 C6.9,20 6,19.1 6,18 L6,10 Z M16,7 L20,7 L20,9 L4,9 L4,7 L8,7 L8,5 C8,4.4 8.4,4 9,4 L15,4 C15.6,4 16,4.4 16,5 L16,7 Z M14,7 L14,6 L10,6 L10,7 L14,7 Z", id: "DELETE-ICON-SVG-PATH" })),
        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("mask", { id: "DELETE-ICON-SVG-mask", fill: "white" },
                React.createElement("use", { xlinkHref: "#DELETE-ICON-SVG-PATH" })),
            React.createElement("g", { fillRule: "nonzero" }),
            React.createElement("g", { mask: "url(#DELETE-ICON-SVG-mask)", fill: color },
                React.createElement("rect", { x: "0", y: "0", width: "24", height: "24" })))));
};
exports.Delete = Delete;
//# sourceMappingURL=Delete.js.map